// extracted by mini-css-extract-plugin
export var divider = "_np-0";
export var systemMessage = "_np-1";